/**
 * Chien, écart et mains sous la grille des plis (stats différé).
 * Aligné sur MlCompareDealPostTricksPanel du benchmark ML.
 */

import type { DiffereStatsDealDetail } from '../../utils/differeStatsReplay';
import {
  DEAL_SEAT_LABELS,
  formatDealCardRowShort,
  handsAtStartOfTrick,
  renderDealHandGroupedSegments,
} from '../../utils/dealHandsAtTrick';

export default function DiffereStatsDealHandsPanel({
  detail,
  trickFocusTrickNum1,
  studiedSeat = 0,
}: {
  detail: Pick<
    DiffereStatsDealDetail,
    'contract' | 'takerPosition' | 'initialHands' | 'chien' | 'ecart' | 'tricks'
  >;
  /** null = tirage ; N = mains au début du pli N (cartes déjà jouées retirées). */
  trickFocusTrickNum1: number | null;
  studiedSeat?: number;
}) {
  const chien = detail.chien ?? [];
  const ecart = detail.ecart ?? [];
  const hands = handsAtStartOfTrick(detail, trickFocusTrickNum1);

  return (
    <div className="ml-compare-deal-post-tricks">
      {trickFocusTrickNum1 == null ? (
        <div className="ml-compare-deal-post-tricks-hint">
          Mains au tirage (18 cartes par joueur, avant chien et écart). Cliquez sur un numéro de pli pour
          afficher les mains avant ce pli.
        </div>
      ) : trickFocusTrickNum1 > 1 ? (
        <div className="ml-compare-deal-post-tricks-hint">
          Mains au début du pli {trickFocusTrickNum1} — cartes déjà jouées aux plis précédents masquées.
          Re-cliquez sur le pli pour revenir au tirage.
        </div>
      ) : (
        <div className="ml-compare-deal-post-tricks-hint">
          Mains après chien et écart, avant le pli 1. Re-cliquez sur le pli pour revenir au tirage.
        </div>
      )}
      <div className="ml-compare-deal-post-tricks-line">
        <span className="ml-compare-deal-post-tricks-k">Chien :</span>{' '}
        <span className="ml-compare-deal-post-tricks-cards">{formatDealCardRowShort(chien)}</span>
      </div>
      <div className="ml-compare-deal-post-tricks-line">
        <span className="ml-compare-deal-post-tricks-k">Écart :</span>{' '}
        <span className="ml-compare-deal-post-tricks-cards">{formatDealCardRowShort(ecart)}</span>
      </div>
      {hands ? (
        hands.map((hand, seat) => {
          const segments = renderDealHandGroupedSegments(hand);
          return (
            <div key={seat} className="ml-compare-deal-post-tricks-line">
              <span
                className={[
                  'ml-compare-deal-post-tricks-k',
                  seat === studiedSeat ? 'ml-compare-deal-post-tricks-k-studied' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                {DEAL_SEAT_LABELS[seat] ?? seat} :
              </span>{' '}
              <span className="ml-compare-deal-post-tricks-cards ml-compare-deal-post-tricks-hand-grouped">
                {segments.length === 0
                  ? '—'
                  : segments.map((seg, i) => (
                      <span
                        key={`${seat}-${i}`}
                        className={
                          i === 0 ? 'ml-compare-hand-block' : 'ml-compare-hand-block ml-compare-hand-block-gap'
                        }
                      >
                        {seg}
                      </span>
                    ))}
              </span>
            </div>
          );
        })
      ) : (
        <div className="ml-compare-deal-post-tricks-line ml-compare-deal-post-tricks-muted">
          Mains : données indisponibles (initialHands manquant).
        </div>
      )}
    </div>
  );
}
